module.exports = __webpack_public_path__ + "static/media/image18.8e1943d1.JPG";